export const ClientesImg = [
  {
    title: "Sector financiero",
    path: "../../../clientes/img1.jpg",
    cName: "img1 carousel-img-clientes",
  },
  {
    title: "Sector de Salud",
    path: "../../../clientes/img2.jpg",
    cName: "img2 carousel-img-clientes",
  },
  {
    title: "Hotelería",
    path: "../../../clientes/img3.jpg",
    cName: "img3 carousel-img-clientes",
  },
  {
    title: "Organismos gubernamentales",
    path: "../../../clientes/img4.jpg",
    cName: "img4 carousel-img-clientes",
  },
  {
    title: "Retail",
    path: "../../../clientes/img5.png",
    cName: "img5 carousel-img-clientes",
  },
  {
    title: "Educación",
    path: "../../../clientes/img6.jpg",
    cName: "img6 carousel-img-clientes",
  },
  {
    title: "Farmaceutica",
    path: "../../../clientes/img7.jpg",
    cName: "img7 carousel-img-clientes",
  },
  {
    title: "Energía",
    path: "../../../clientes/img8.jpg",
    cName: "img8 carousel-img-clientes",
  },
  {
    title: "Agro/Forestal/Ganadero",
    path: "../../../clientes/img9.jpg",
    cName: "img9 carousel-img-clientes",
  },
  {
    title: "Servicios",
    path: "../../../clientes/img10.jpg",
    cName: "img10 carousel-img-clientes",
  },
  {
    title: "Corporativo",
    path: "../../../clientes/img11.jpg",
    cName: "img11 carousel-img-clientes",
  },
  {
    title: "Industria",
    path: "../../../clientes/img12.jpg",
    cName: "img12 carousel-img-clientes",
  },
]
